import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

interface TemplateProps {
  pageId: number
}
const categoryTitle = 'サービス'
const baseUrl = '/cases/service/'

const Template: React.FC<TemplateProps> = ({ pageId }) => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={pageId} />
}

export default Template
